import * as ActionType from '../actions/results';
import ResultState from "../../constants/ResultState";
import Logger from "../../tools/logger";

const defaultState = {
	resultsState: ResultState.LOADING
};

/**
 * @description
 * get the results data required for every page of the app.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function results (state = defaultState, action) {
	let newState = { ...state };

	switch (action.type) {

		case ActionType.REQUEST_GET : {
			newState.resultsState = ResultState.LOADING;
			return newState;
		}

		case ActionType.SUCCESS_GET : {

			newState = action.payload;
			newState.resultsState = ResultState.RESULTS_FETCHED;

			return newState;
		}

		case ActionType.FAILURE_GET : {

			if (action.payload && action.payload.status === 404) {
				newState.resultsState = ResultState.NO_RESULTS;

				Logger.instance.notice({
					component: 'results',
					message: 'No results found (404), results set should be created for this participant'
				});
			} else {
				newState.resultsState = ResultState.ERROR_FETCHING;

				if (action.payload && action.payload.status !== 401) {
					Logger.instance.error({
						component: 'results',
						message: `Error while fetching results: ${JSON.stringify(action.payload)}`
					});
				}
			}

			return newState;
		}

		case ActionType.REQUEST_POST : {
			newState.resultsState = ResultState.CREATING_RESULTS;
			return newState;
		}

		case ActionType.SUCCESS_POST : {
			newState.resultsState = ResultState.INIT_SUCCESS;

			Logger.instance.notice({
				component: 'results',
				message: 'Results set successfully created for this participant'
			});

			return newState;
		}

		case ActionType.FAILURE_POST : {
			newState.resultsState = ResultState.INIT_ERROR;

			if (action.payload && action.payload.status !== 401) {
				Logger.instance.error({
					component: 'results',
					message: `Results set could not be created for this participant: ${JSON.stringify(action.payload)}`
				});
			}

			return newState;
		}

		case ActionType.REQUEST_UPDATE : {
			if (action.meta.players) {
				newState.saveState.players = action.meta.players;
			}
			if (action.meta.answers) {
				newState.saveState.answers = action.meta.answers;
			}
			if (action.meta.avatar) {
				newState.saveState.avatar = action.meta.avatar;
			}

			// unexpected error response
			if (action.payload) {
				newState.resultsState = ResultState.UPDATE_ERROR;
				if (action.payload.status !== 401) {
					Logger.instance.error({
						component: 'results',
						message: `Unexpected error while saving answer (error is shown): ${JSON.stringify(action.payload)}, answer: ${JSON.stringify(action.meta)}`
					});
				}
			}

			Logger.instance.notice({
				component: 'results',
				message: `Requesting save answer: ${JSON.stringify(action.meta)}`
			});

			return newState;
		}

		case ActionType.SUCCESS_UPDATE : {
			newState.resultsState = ResultState.UPDATE_SUCCESS;

			Logger.instance.notice({
				component: 'results',
				message: `Success saving answer: ${JSON.stringify(action.meta)}`
			});

			return newState;
		}

		case ActionType.FAILURE_UPDATE : {
			newState.resultsState = ResultState.UPDATE_ERROR;

			if (action.payload && action.payload.status !== 401) {
				Logger.instance.error({
					component: 'results',
					message: `Failed saving answer (error is shown): ${JSON.stringify(action.payload)}, answer: ${JSON.stringify(action.meta)}`
				});
			}

			return newState;
		}

		case ActionType.UPDATE_CURRENT_ANSWER : {
			newState.answer = action.answer;
			return newState;
		}

		case ActionType.UPDATE_SAVE_STATE : {
			if (action.save) {
				newState.players = action.save.players || state.players;
				newState.avatar = action.save.avatar || state.avatar;
			}
			return newState;
		}

		default:
			return state;
	}
}
